import { useTranslation } from 'react-i18next'

import { LeafletStaticMap } from '@/shared/map'

import { SecaoDetalhesEmpreendimento } from './secao'

interface SecaoLocalizacaoProps {
  endereco?: string | null
  latitude?: string | null
  longitude?: string | null
}

export const SecaoLocalizacao = ({ endereco, latitude, longitude }: SecaoLocalizacaoProps) => {
  const { t } = useTranslation('empreendimentos')

  return (
    <SecaoDetalhesEmpreendimento titulo={t('pages.detalhes.secoes.localizacao.titulo')}>
      <p>{endereco ?? t('pages.detalhes.secoes.localizacao.sem_informacoes')}</p>
      {latitude && longitude && (
        <LeafletStaticMap
          latitude={latitude}
          longitude={longitude}
          zoom={24}
          iconUrl="/images/markerPlaenge.png"
          iconWidth={32}
          iconHeight={43}
          popupContent={endereco ?? t('pages.detalhes.secoes.localizacao.popup_padrao')}
          className="h-104 w-213 rounded border"
        />
      )}
    </SecaoDetalhesEmpreendimento>
  )
}
